// Geografía vectorial del mundo (proyección equirectangular, viewBox 1000x500).
// Cada masa de tierra es un anillo de [lon, lat]. Se proyecta, se suaviza con
// corte de esquinas (Chaikin) y se exporta como un único trazo SVG.
export const MAP_W = 1000;
export const MAP_H = 500;

const px = (lon) => ((lon + 180) / 360) * MAP_W;
const py = (lat) => ((90 - lat) / 180) * MAP_H;

const NORTH_AMERICA = [
  [-168,65.6],[-166,68.3],[-162,70.2],[-156.5,71.3],[-152,70.8],[-141,69.7],[-135,69.4],[-128,70.2],[-123,69.4],[-115,68],[-108,68.2],
  [-100,67.8],[-96,68.5],[-94.5,71.5],[-90.5,69],[-85.5,69.8],[-82,67.5],[-86,66],[-87.5,64.2],[-93,61.5],[-94.5,59],[-92.5,57.2],
  [-88,56.5],[-82.3,55.2],[-82.2,53],[-79.5,51.5],[-78.8,54.5],[-77.5,58.2],[-78,60.7],[-77,62.4],[-73,62],[-70,61],[-69.5,58.8],
  [-65,60.2],[-62,57.8],[-61,55.5],[-57,53.2],[-56,51.7],[-60,50.2],[-65,50],[-68.5,48.5],[-64.5,49],[-64.8,47.5],[-63,46.5],
  [-61,45.7],[-64,44.5],[-66.2,43.7],[-67,45],[-70,43.7],[-70.7,42.2],[-71,41.5],[-74,40.5],[-74.2,39.5],[-75.8,37.5],[-75.7,35.3],
  [-77.5,34.3],[-79.8,32.8],[-81.2,31.2],[-81,29],[-80.1,26.8],[-80.3,25.2],[-81.2,25.2],[-82.2,26.8],[-82.7,28.7],[-84,30],
  [-85.5,29.7],[-87.5,30.3],[-89.3,30.3],[-89.5,29.1],[-91.5,29.5],[-94,29.6],[-96,28.4],[-97.4,26.5],[-97.8,24.2],[-97.6,22.3],
  [-96.3,19.4],[-95,18.7],[-93.5,18.4],[-91.5,18.5],[-90.5,19.8],[-90.4,21],[-88,21.5],[-86.8,21.2],[-87.8,19],[-88.2,16.8],
  [-88.9,15.9],[-85.5,15.9],[-83.3,15.1],[-83.5,12.5],[-83.7,11],[-82.2,9.3],[-80.2,9.1],[-79.1,9.5],[-77.3,8.7],[-77.4,7.3],
  [-78.4,8],[-79.5,8.9],[-80.5,7.4],[-82,8.3],[-83.5,8.6],[-85.7,10],[-87.5,13],[-90,13.8],[-92.2,14.5],[-94.2,16.1],[-96.5,15.7],
  [-98.8,16.4],[-101.5,17.7],[-103.5,18.5],[-105.5,20.2],[-105.4,22],[-106.5,23.5],[-108.5,25.5],[-110.3,27.5],[-112.3,29.3],
  [-113.8,31.2],[-114.8,31.8],[-114.3,30.2],[-112.8,28.5],[-111.2,26],[-109.7,23.4],[-110,22.9],[-112,24.4],[-114.5,27.3],
  [-115.6,29.8],[-116.8,31.8],[-117.3,33],[-118.5,34],[-120.5,34.5],[-121.9,36.6],[-122.5,37.8],[-123.8,39.4],[-124.3,40.5],
  [-124,43],[-124,46.2],[-124.7,48.3],[-123,48.5],[-123,49.2],[-125,50],[-127.5,51.5],[-129,53],[-130.5,54.7],[-132.5,56.3],
  [-134,58.2],[-137,59],[-140,59.8],[-144,60],[-147.5,60.8],[-150,59.3],[-152,59.5],[-154,58],[-157,57.2],[-161,55.5],[-164.5,54.7],
  [-162,56.2],[-158.5,57.8],[-157.5,58.8],[-161,59],[-162.5,60.2],[-165,61.2],[-165.5,62.5],[-161,63.5],[-161,64.5],[-166.5,64.5],
];

const SOUTH_AMERICA = [
  [-77.3,8.7],[-75.5,10.8],[-72,12],[-71.3,11],[-68,10.5],[-64,10.6],[-61,10.5],[-60,8.5],[-57,6],[-52,5],[-50,1.5],[-50,-0.5],
  [-45,-1.5],[-41,-2.8],[-37,-5],[-35,-6.5],[-35,-9],[-38.5,-13],[-39,-17.5],[-41,-22],[-44,-23],[-48.5,-26],[-48.8,-28.5],
  [-52,-32],[-54,-34.8],[-57,-35],[-56.5,-37.3],[-58,-38.5],[-62,-39],[-62.3,-41],[-65,-41],[-63.5,-42.7],[-65.5,-45],
  [-67.5,-46.5],[-66,-48],[-68.5,-50.2],[-69,-52.3],[-68.4,-53.8],[-65.5,-54.8],[-68,-55.5],[-72,-54],[-74,-52],[-75.5,-48.5],
  [-73.5,-44],[-73.5,-40],[-73.2,-37],[-71.7,-33],[-71.5,-28],[-70.3,-23],[-70.2,-18.5],[-75,-15],[-79,-10],[-81,-6],[-81,-4.5],
  [-80,-2.5],[-80,0],[-79,1.7],[-77.5,4],[-77.4,7],
];

const EURASIA = [
  [-9.5,38.7],[-9,41.5],[-8.8,43.3],[-3.5,43.5],[-1.8,43.4],[-1.2,46],[-2.3,47.2],[-4.7,48.4],[-1.6,48.7],[-1.2,49.7],[1.5,50.9],
  [3.5,51.4],[4.6,52.9],[6.5,53.6],[8.6,53.9],[8.3,55.5],[8.2,57.1],[10.5,57.7],[10.5,55.5],[9.9,54.8],[11,54.2],[14,54],
  [18.5,54.8],[21,55.3],[21,56.8],[23.7,57],[24.4,58.4],[23.5,59.2],[28,59.5],[30,60],[26,60.4],[23,59.9],[21.5,60.8],[21.3,62.5],
  [23,64],[25.4,65],[24.5,65.8],[22,65.7],[21,64.3],[19,63],[17.3,62],[17.5,60.5],[18.8,59.8],[16.8,58.5],[16.5,57],[14.5,56],
  [13,55.4],[12.6,56.2],[11.8,57.7],[11,59],[9.5,59],[7.5,58.1],[5.6,58.9],[5,60.5],[5.2,62],[7.5,63.3],[10.5,64.5],[12.8,66.2],
  [14.5,68],[17,69.3],[19.5,70.2],[23.5,70.7],[27,71],[31,70.3],[33.5,69.4],[41,67.7],[42.5,66.4],[44.5,66.4],[44,68.3],[48,68.5],
  [53,68.8],[59,68.5],[60.5,69.8],[66,69.2],[67,71],[69.5,73],[72.5,72.8],[72.5,71],[75,72.3],[80,72.3],[80.5,73.8],[87,75.2],
  [94,76],[100,77.4],[104,77.7],[107,76.7],[113,75.8],[113.5,73.8],[119,73.3],[127,73.4],[129,71.3],[133,71.4],[139,71.6],[141,73],
  [146,72.3],[150.5,71.5],[154,70.8],[160,69.6],[165,69.5],[170,70],[176,69.7],[180,68.9],[180,65.6],[178.5,64.5],[176,63.2],
  [172.5,61.3],[170,60],[166,59.8],[163.5,59.6],[162.5,57.5],[163.2,56],[160,53],[156.7,51],[155.7,54],[155.5,57.2],[158,58.5],
  [162,60.8],[159,61.5],[155,59.5],[150,59.3],[143,59.3],[140.5,57.5],[138,56],[135.5,54.5],[137.2,54],[140.7,53.2],[141.2,52],
  [140.5,50],[140.3,48],[138,46],[135.5,43.7],[132,42.9],[130.8,42.3],[129.7,41],[128,39.7],[129.4,37],[129.3,35.2],[127.5,34.6],
  [126.4,34.6],[126.3,36.6],[126.8,37.8],[125.2,37.7],[125,39.5],[123.5,39.7],[121.7,38.9],[121.5,40.5],[119.5,39.8],[117.7,38.9],
  [118.8,37.4],[120.7,37.8],[122.5,37],[120.5,35.5],[119.2,34.5],[120.8,32.5],[121.9,31.6],[121.2,30.2],[122,29.5],[121,28],
  [119.7,26],[118,24.5],[116.5,23.2],[114.3,22.3],[113.5,22.2],[111.5,21.5],[110.3,21.2],[110,20.3],[108.5,21.6],[107,20.9],
  [105.9,19.5],[107,17],[108.8,15.4],[109.3,12.8],[109,11.5],[107,10.4],[105,8.6],[104.8,10],[103,10.8],[100.9,12.7],[99.8,10.5],
  [100.3,8.5],[102,6.2],[103.4,4.5],[103.5,2.5],[104.2,1.4],[103.5,1.3],[101.5,2.8],[100.5,4.5],[100.4,6.3],[98.5,8.3],[98.4,10.5],
  [98.7,13],[97.7,15.5],[97.4,17],[95.5,15.8],[94.3,16.2],[94.4,18.5],[93.5,19.5],[92.3,21.2],[91.8,22.3],[90.5,22.4],[89,21.8],
  [87.5,21.6],[86.8,20.5],[85,19.4],[83,17.3],[81.5,16.3],[80.2,15.2],[80.1,13],[79.9,11],[79.8,10.2],[78.8,9.1],[77.8,8.1],
  [77.2,8.2],[76.4,9.5],[75.6,11.7],[74.8,13.5],[74,15.4],[73.4,17.5],[72.9,19.5],[72.8,21],[72.5,21.8],[70.8,21],[69.2,22.3],
  [70.2,22.9],[68.4,23.5],[67,24.8],[66.5,25.4],[64.5,25.2],[61.5,25.2],[59,25.4],[57.3,25.8],[56.6,27.1],[54.8,26.5],[52.5,27.5],
  [51.2,28.1],[50.3,29.9],[48.8,30.2],[48.2,29.5],[49,27.7],[49.8,26.9],[50.2,26.3],[51.5,24.6],[54,24.2],[55.5,25.4],[56.3,26.3],
  [56.4,24.7],[58,23.7],[59.8,22.5],[58.7,20.5],[57.8,19],[56.3,17.9],[54,16.7],[52,16],[49,14.3],[45,12.8],[43.4,12.8],[42.7,15],
  [41.6,17.5],[39.8,21.3],[38.3,24.2],[36.8,26.5],[35,28],[34.9,29.5],[34.3,31.2],[35,32.8],[35.8,34.5],[35.9,36.4],[34.5,36.7],
  [32.5,36.1],[30.5,36.3],[28.5,36.7],[27.3,37.4],[26.3,38.3],[26.5,39.5],[26.2,40.1],[26,40.8],[24.5,40.9],[23.7,40.3],
  [22.8,40.3],[22.9,39.3],[23.8,38.4],[24,37.7],[23.1,36.5],[22.4,36.5],[21.7,36.9],[21.2,38.2],[20.5,39.6],[19.4,40.4],
  [19.5,41.9],[18.5,42.6],[16.5,43.5],[15.2,44.5],[13.7,45.2],[13.7,45.6],[12.3,45.3],[12.4,44.2],[13.6,43.6],[14.4,42.2],
  [16.2,41.8],[18.5,40.2],[17.2,40.4],[16.6,39.7],[17.1,39],[16.5,38.4],[15.7,38],[15.9,38.8],[15.7,40],[14.2,40.8],[13,41.3],
  [12,42],[10.6,43],[10.2,43.9],[8.8,44.4],[7.5,43.8],[6,43.1],[4.5,43.4],[3.2,43.1],[3.1,41.9],[1,41.1],[-0.3,39.5],[-0.5,38.2],
  [-1.5,37.2],[-2.5,36.7],[-4.4,36.7],[-5.4,36],[-6.3,36.6],[-7.4,37.2],[-8.9,37],[-8.9,38.4],
];

// Mares interiores (se recortan del continente con regla par-impar).
const BLACK_SEA = [
  [29.1,41.2],[31.5,41.1],[34,42],[36,41.4],[38,40.9],[41.5,41.5],[41.6,42.8],[39.5,43.9],[37.5,44.8],[38.3,46],[35,45.4],
  [33.5,44.5],[32.5,45.5],[33.5,46.1],[31,46.5],[30.2,45.5],[29.6,44.8],[28.7,43.5],[27.9,42.3],
];
const CASPIAN = [
  [47.5,45],[49,46.4],[51.5,47],[53.2,46.7],[53,44.7],[51,44.5],[50.3,43.2],[51.5,42.2],[53,41.5],[53,40],[53.8,38.5],[53.9,37.3],
  [51,36.8],[49.2,37.5],[49,38.5],[49.5,40.3],[48,42],[47.5,43.5],[47.2,44.5],
];

const AFRICA = [
  [-5.9,35.8],[-2.9,35.3],[0,35.9],[3,36.8],[6,37],[9.8,37.3],[10.2,36.8],[11,36.9],[10.3,35.8],[11,35.2],[10.1,33.9],[11.2,33.2],
  [13.2,32.9],[15.2,32.3],[15.5,31.1],[18.5,30.3],[20,31],[20.2,32.2],[22.5,32.9],[25,31.8],[27,31.4],[29,30.9],[32.3,31.3],
  [34.2,31.3],[34.9,29.5],[34.3,27.8],[32.6,29.9],[33.6,27.3],[35.5,24.2],[36.9,21.8],[37.3,18.8],[39.2,15.5],[41.5,13.5],
  [43.2,12.4],[43.1,11.6],[44.5,10.4],[47,11.2],[51,11.8],[51,10.4],[49.5,8],[47.5,4.9],[45,2],[42,-0.9],[40.5,-2.5],[39.2,-4.7],
  [39.2,-7],[39.5,-9.5],[40.5,-10.7],[40.6,-14.5],[39,-16.8],[36,-18.8],[35.2,-21.8],[35.5,-24],[33,-25.6],[32.9,-26.9],
  [32.7,-28.5],[30.8,-30.4],[28,-33],[25.7,-34],[23.5,-34],[20,-34.8],[18.4,-34.2],[18.2,-32],[17,-29],[15.2,-27],[14.5,-23],
  [11.8,-17.2],[12.5,-14],[13.8,-11],[13,-8.5],[12.2,-6],[11.8,-4.5],[9.3,-2],[9.3,0.5],[9.6,3],[8.8,4.2],[7,4.4],[5.5,5.5],
  [4.3,6.3],[2,6.2],[-1,5],[-3,5.1],[-5,5.1],[-7.5,4.4],[-9.5,5.5],[-12,7.2],[-13.3,8.8],[-14.7,10.5],[-16.7,12.5],[-17.4,14.7],
  [-16.5,16.5],[-16.2,19],[-16.8,21.2],[-15.5,23.8],[-14.5,26.2],[-12.8,27.9],[-10.5,29.5],[-9.8,31.2],[-9.2,32.6],[-7,33.8],
  [-6.5,34.6],
];

const AUSTRALIA = [
  [113.5,-22],[114,-26],[115,-34],[118,-35],[123.5,-34],[126,-32.3],[131,-31.5],[134.2,-32.7],[135.5,-34.7],[137.8,-33],
  [137.5,-35.2],[139.5,-36],[140.5,-38],[144,-38.4],[146.4,-39],[150,-37.5],[153,-31],[153.5,-27],[153,-25],[150.5,-22.5],
  [149,-20.5],[146,-18.8],[145.5,-15],[143.5,-14],[142.5,-10.7],[141.5,-13],[141.7,-15.5],[140.5,-17.7],[139,-17],[136.5,-15.5],
  [135.5,-14.7],[137,-12.2],[136.7,-12],[133,-11.5],[131,-12.3],[129.5,-14.7],[127.5,-14],[125,-15.5],[122.5,-17.5],[121,-19.5],
  [118,-20.5],
];

const ANTARCTICA = [
  [-180,-92],[-180,-84],[-170,-78.5],[-155,-78],[-145,-76.5],[-130,-74],[-115,-74.5],[-100,-73.5],[-90,-72.5],[-78,-73],
  [-72,-70],[-67,-66],[-62,-64.5],[-58,-63.5],[-60,-66],[-66,-70],[-60,-75],[-45,-78],[-35,-77.5],[-25,-74],[-10,-71.5],
  [10,-70.5],[30,-69.5],[45,-67.5],[60,-67.5],[70,-69.5],[80,-67],[95,-66.5],[110,-66],[125,-66.5],[140,-66.5],[150,-69],
  [160,-70.5],[170,-72],[180,-78],[180,-92],
];

const GREENLAND = [
  [-69,76.8],[-66,78.5],[-62,80.2],[-55,81.6],[-45,82.5],[-31,83.6],[-21,82.5],[-18,79.5],[-20,75],[-22,72],[-25,70.5],[-32,68],
  [-37,65.8],[-41,63],[-43,60],[-46,60.5],[-50,62.5],[-52,64.8],[-53.5,67],[-52,69.5],[-55,71],[-58,75.5],[-66,76.2],
];

const ISLANDS = [
  // Ártico canadiense y Atlántico norte
  [[-63,66],[-65,63.5],[-71,63.8],[-74,64.8],[-78,64.8],[-73.5,67.5],[-77,69.5],[-85,70.2],[-90,72.8],[-85,73.7],[-80,73.7],[-73,72.5],[-67,70]],
  [[-118,70.5],[-115,73],[-108,73.2],[-102,72.5],[-101.5,70.5],[-105,69],[-110,68.7],[-115,69.5]],
  [[-92,76.8],[-85,76.4],[-79,76.6],[-77.5,78.5],[-74,80],[-67,81.4],[-64,82.4],[-72,83.1],[-82,82.7],[-90,81.2],[-92,79],[-90.5,77.6]],
  [[-59,47.7],[-53,46.7],[-53,49.5],[-56,51.5]],
  [[-24,65.5],[-22,66.4],[-16,66.5],[-13.5,65],[-18,63.4],[-22.5,63.8]],
  [[11,79],[20,80.5],[27,80],[18,77]],
  [[52,71],[55,72],[60,75],[68,77],[69,76.5],[58,74],[54,71.5]],
  // Caribe
  [[-85,22],[-80,23],[-74.2,20.2],[-77.5,20],[-82,22.5]],
  [[-74.4,18.5],[-72,19.9],[-68.4,18.6],[-71.5,17.7]],
  // Europa y Mediterráneo
  [[-5.7,50.1],[1.4,51.2],[1.7,52.7],[0,53.5],[-1.5,55],[-2,57],[-1.8,57.6],[-3.5,57.7],[-5,58.6],[-6.2,57.5],[-5.5,55.5],[-4.9,54.8],[-3,54.5],[-3,53.4],[-4.5,53.3],[-5,52],[-3,51.5]],
  [[-6,52.2],[-6,54],[-5.7,54.6],[-8,55.2],[-10,54],[-9.8,52.2],[-8,51.7]],
  [[12.5,38],[15.6,38.3],[15.1,36.7],[12.4,37.6]],
  [[8.2,41],[9.7,41.1],[9.6,39],[8.5,39]],
  [[8.6,42.5],[9.5,43],[9.4,41.4],[8.7,41.6]],
  [[23.5,35.3],[26.3,35.2],[26.2,35],[23.6,35]],
  [[32.3,35],[34.5,35.6],[33.8,34.7],[32.4,34.8]],
  // Asia oriental
  [[130.9,34],[132.5,35.5],[135.5,35.7],[137,37],[139.5,38],[140,40.5],[141.5,41],[141.8,39],[141,38],[140.8,36],[139.8,35],[137,34.6],[135.8,33.5],[134.5,34.5],[132.5,34.2]],
  [[140,42],[141.5,45.4],[145.5,43.4],[143,42],[141,41.8]],
  [[129.8,33],[131.8,33.7],[131.5,31.2],[130.2,31.2]],
  [[142,54],[143,53],[143,49],[142,46],[141.8,49]],
  [[120.2,23],[121,25.2],[122,25],[121.5,22.5]],
  [[108.7,19.5],[110.5,20.1],[111,19.6],[109.5,18.2]],
  [[79.8,9.7],[81.8,7.5],[81.2,6.1],[80,6]],
  // Filipinas e Indonesia
  [[120.5,18.5],[122.2,18.4],[122,16],[124,13],[121,13.5],[120,14.5]],
  [[122,8],[126.5,9.5],[126,6.5],[124,6.2]],
  [[123,11],[125.3,11.5],[125,10],[123.2,9.5]],
  [[95.3,5.6],[98.5,3.8],[100.4,2.3],[103.8,-1],[106,-3.2],[105.8,-5.9],[104.5,-5.9],[101,-3],[99,-0.5],[97.5,1.8]],
  [[105.2,-6.8],[108.5,-6.5],[112.8,-6.9],[114.5,-7.7],[114.4,-8.7],[108,-7.8]],
  [[109,1.5],[111,2.3],[113,3.2],[116,6.9],[117.8,6.5],[119,5.2],[118,4],[117.8,1],[116.5,-1.5],[116.3,-3.8],[114.5,-4],[111.7,-3.3],[110.2,-2.9],[109.2,-0.5]],
  [[119.4,-5.5],[119.4,0],[120.5,1.2],[124.8,1.6],[121,0.3],[123,-0.8],[121.5,-1.8],[123,-4],[121.8,-4.8],[120.5,-3],[120.4,-5.5]],
  [[131,-0.8],[134,-0.8],[138,-1.7],[141,-2.6],[145,-4.5],[148,-6],[147.5,-7.8],[144,-7.7],[141,-9.1],[138,-8.3],[138,-6],[135,-4.5],[133,-4]],
  // Oceanía y África
  [[144.7,-40.7],[148.3,-40.9],[148,-43],[146.2,-43.6]],
  [[172.7,-34.5],[175,-37],[178.5,-37.7],[176.5,-40.5],[175,-41.5],[174.8,-39.5],[173.8,-39.2],[174.5,-37]],
  [[172.7,-40.5],[174.3,-41.7],[173,-43.5],[171,-44.4],[170.7,-45.9],[168.3,-46.6],[166.5,-46],[168,-44.2],[171.5,-41.7]],
  [[49.3,-12],[50.5,-15.5],[47.5,-24.8],[44,-25],[43.3,-22],[44.5,-16],[47,-15]],
  // Extremo oriental de Chukotka (cruza el antimeridiano)
  [[-180,68.9],[-175,67.6],[-170,66],[-172.5,64.5],[-177,65.5],[-180,65.6]],
];

// Corte de esquinas: suaviza el contorno sin salirse del polígono original.
function chaikin(pts, iterations = 2, r = 0.22) {
  let cur = pts;
  for (let k = 0; k < iterations; k++) {
    const next = [];
    for (let i = 0; i < cur.length; i++) {
      const a = cur[i];
      const b = cur[(i + 1) % cur.length];
      next.push([a[0] + (b[0] - a[0]) * r, a[1] + (b[1] - a[1]) * r]);
      next.push([a[0] + (b[0] - a[0]) * (1 - r), a[1] + (b[1] - a[1]) * (1 - r)]);
    }
    cur = next;
  }
  return cur;
}

function ringToPath(ring) {
  const pts = chaikin(ring.map(([lon, lat]) => [px(lon), py(lat)]));
  return "M" + pts.map(([x, y]) => `${x.toFixed(1)} ${y.toFixed(1)}`).join("L") + "Z";
}

export const LAND_PATH = [
  NORTH_AMERICA, SOUTH_AMERICA, EURASIA, BLACK_SEA, CASPIAN, AFRICA, AUSTRALIA, ANTARCTICA, GREENLAND, ...ISLANDS,
].map(ringToPath).join("");

// Rejilla de meridianos y paralelos cada 30°.
export const GRATICULE_PATH = (() => {
  const d = [];
  for (let lon = -150; lon <= 150; lon += 30) d.push(`M${px(lon)} 0V${MAP_H}`);
  for (let lat = -60; lat <= 60; lat += 30) if (lat !== 0) d.push(`M0 ${py(lat)}H${MAP_W}`);
  return d.join("");
})();
export const EQUATOR_PATH = `M0 ${py(0)}H${MAP_W}M0 ${py(23.4)}H${MAP_W}M0 ${py(-23.4)}H${MAP_W}`;

// Hubs logísticos (x,y en el viewBox) y rutas [origen, destino, duración_s].
export const HUBS = [
  { n: "Ciudad de México", x: 225, y: 196, label: true },
  { n: "Guadalajara", x: 213, y: 193 },
  { n: "Monterrey", x: 221, y: 179 },
  { n: "Los Ángeles", x: 172, y: 155 },
  { n: "Miami", x: 277, y: 178 },
  { n: "Nueva York", x: 294, y: 137, label: true },
  { n: "Londres", x: 500, y: 107, label: true },
  { n: "Madrid", x: 490, y: 138 },
  { n: "Frankfurt", x: 524, y: 111 },
  { n: "Dubái", x: 654, y: 180, label: true },
  { n: "Shanghái", x: 837, y: 163, label: true },
  { n: "Tokio", x: 888, y: 151, label: true },
  { n: "Singapur", x: 788, y: 246 },
  { n: "São Paulo", x: 371, y: 315, label: true },
  { n: "Buenos Aires", x: 338, y: 346 },
  { n: "Sídney", x: 920, y: 344, label: true },
];

export const ROUTES = [
  [0, 11, 7], [0, 5, 4], [0, 13, 5], [3, 10, 8], [4, 6, 6],
  [5, 8, 5], [9, 10, 6], [6, 15, 9], [12, 9, 5], [7, 0, 6],
  [1, 2, 3], [2, 4, 4],
];

// Arco curvo entre dos hubs (curva cuadrática hacia el norte).
export function arc(x1, y1, x2, y2) {
  const mx = (x1 + x2) / 2, my = (y1 + y2) / 2;
  const dx = x2 - x1, dy = y2 - y1;
  const len = Math.hypot(dx, dy) || 1;
  const nx = -dy / len, ny = dx / len;
  const off = len * 0.18;
  const s = ny > 0 ? -1 : 1;
  const cx = mx + nx * off * s, cy = my + ny * off * s;
  return `M ${x1.toFixed(1)} ${y1.toFixed(1)} Q ${cx.toFixed(1)} ${cy.toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
}